import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-attendee-category',
  templateUrl: './category.component.html',
})
export class AttendeeCategoryComponent {
  @Input() public description: string;
  @Input() public image: string;
  @Input() public title: string;
}
